(function () {
  var bar = document.getElementById('stickyBar');
  var hero = document.querySelector('.hero') || document.getElementById('buy');
  if (bar && hero) {
    var onScroll = function () {
      var trigger = hero.getBoundingClientRect().bottom;
      if (trigger < 0) bar.classList.add('show');
      else bar.classList.remove('show');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Progressive-enhancement reveal: content is visible by default (see CSS).
     Only if this runs do we opt elements into a pre-hidden state, then reveal
     them on scroll — so a script failure or slow load never hides content. */
  if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && 'IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('[data-reveal]');
    revealEls.forEach(function (el) { el.classList.add('pre-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('pre-reveal');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  var searchToggle = document.getElementById('searchToggle');
  var searchClose = document.getElementById('searchClose');
  var headerSearch = document.getElementById('headerSearch');
  if (searchToggle && headerSearch) {
    var openSearch = function () {
      headerSearch.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      var input = headerSearch.querySelector('input[type="search"]');
      if (input) input.focus();
    };
    var closeSearch = function () {
      headerSearch.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    };
    searchToggle.addEventListener('click', function () {
      if (headerSearch.hidden) openSearch(); else closeSearch();
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  var menuToggle = document.getElementById('menuToggle');
  var mobileNav = document.getElementById('mobileNav');
  var mobileNavBackdrop = document.getElementById('mobileNavBackdrop');
  var mobileNavClose = document.getElementById('mobileNavClose');
  if (menuToggle && mobileNav && mobileNavBackdrop) {
    var openMenu = function () {
      mobileNav.hidden = false;
      mobileNavBackdrop.hidden = false;
      requestAnimationFrame(function () {
        mobileNav.classList.add('open');
        mobileNavBackdrop.classList.add('open');
      });
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeMenu = function () {
      mobileNav.classList.remove('open');
      mobileNavBackdrop.classList.remove('open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        mobileNav.hidden = true;
        mobileNavBackdrop.hidden = true;
      }, 280);
    };
    menuToggle.addEventListener('click', function () {
      if (mobileNav.hidden) openMenu(); else closeMenu();
    });
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeMenu);
    mobileNavBackdrop.addEventListener('click', closeMenu);
    mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-increase], [data-qty-decrease]');
    if (!btn) return;
    var wrap = btn.closest('.qty-stepper');
    var input = wrap && wrap.querySelector('.qty-input');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var value = parseInt(input.value, 10) || min;
    value = btn.hasAttribute('data-qty-increase') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();